// Tool

jQuery(function ($) {
  function simulateDownload(linkUrl) {
    // Create a temporary anchor element
    var link = document.createElement("a");
    link.href = linkUrl;
    link.setAttribute("download", ""); // Set the download attribute

    // Simulate a click event
    var clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: false,
    });

    link.dispatchEvent(clickEvent);
  }

  $("button.download-tool").on("click", function (e) {
    const version = $(this).data("version");
    const toolType = $(this).data("type");
    const acceptedToolTypes = ["erm", "itas"];
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get("email");
    const key = urlParams.get("key");

    if (version && email && key && acceptedToolTypes.includes(toolType)) {
      const params = new URLSearchParams();
      params.append("email", email);
      params.append("key", key);
      params.append("v", version);

      let toolUrl = "";
      if (toolType === "erm") {
        toolUrl = "electoral-risk-management-tool";
      } else if (toolType === "itas") {
        toolUrl = "integritas-threat-assessment-system";
      }

      const downloadQueryString = params.toString();
      const downloadUrl = `/data-tools/tools/${toolUrl}/download?${downloadQueryString}`;
      // window.open(downloadUrl);
      simulateDownload(downloadUrl);
    } else {
      console.log("Download URL is missing some required param");
    }
  });
});
